/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-tagless-components, getter-return */
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { service } from '@ember/service';
import GoalState from '@linc-technologies/linced-common/enums/goal-state';
import { sortBy } from '@linc-technologies/linced-common/utils/arrays';
import { saveOrDiscard } from '@linc-technologies/linced-common/utils/record-rollback';

export default class GoalTableCard extends Component {
  GoalState = GoalState;

  // Services
  @service
  session;

  @service
  store;

  @service
  toaster;

  learner = null;
  goal = null;
  goalStates = null;

  // `showGraderOverride` lets callers override the computed default; Ember < 4
  // allowed that implicitly (computed-property.override).
  showGraderOverride = null;

  @computed('goal.subject', 'showGraderOverride')
  get showGrader() {
    if (this.showGraderOverride !== null) {
      return this.showGraderOverride;
    }

    return this.goal.get('subject.isGradable');
  }

  @computed('goalStates.@each.createTime')
  get latestState() {
    if (!isEmpty(this.goalStates)) {
      return sortBy(this.goalStates, 'createTime').reverse()[0];
    }
  }

  refreshStates() {}

  @computed('latestState.awarded')
  get className() {
    if (isEmpty(this.latestState)) {
      return '';
    }
    switch (this.latestState.awarded) {
      case GoalState.SECURE:
        return 'goal-secure';
      case GoalState.DEVELOPING:
        return 'goal-developing';
      default:
        return '';
    }
  }

  @computed('latestState.grade')
  get actionsDisabled() {
    if (isEmpty(this.latestState)) {
      return false;
    }
    return !!this.latestState.grade;
  }

  @action
  updateState(ev) {
    if (
      ev.target.tagName.toLowerCase() === 'button' ||
      ev.target.parentNode.tagName.toLowerCase() === 'button'
    ) {
      // User clicked on the goal-grader; don't toggle the state.
      return;
    }
    let awarded = GoalState.DEVELOPING;
    let grade = null;
    if (!isEmpty(this.latestState)) {
      switch (this.latestState.awarded) {
        case GoalState.DEVELOPING:
          awarded = GoalState.SECURE;
          break;
        case GoalState.SECURE:
          awarded = GoalState.NOT_SET;
          break;
      }
      if (!isEmpty(this.latestState.grade)) {
        grade = this.latestState.grade;
      }
    }
    let stateParams = {
      schoolId: this.get('session.school'),
      assessorId: this.get('session.person'),
      personId: this.get('learner.person'),
      goalId: this.goal,
      awarded,
    };
    if (!isEmpty(grade)) {
      stateParams.grade = grade;
    }
    let newState = this.store.createRecord('goals/state', stateParams);

    saveOrDiscard(newState)
      .then(() => {
        this.refreshStates();
      })
      .catch(() => this.toaster.error('Error saving the goal state.'));
  }

  @action
  noOp() {}
}
